import { DeepPartial } from 'react-hook-form';
import { InterestedParty } from 'src/pages/payment-msi/PaymentMsiV2/types';

interface IsInterestedPartySwitchEnabledArgs {
  isLandlord: boolean;
  defaultInterestedParty: DeepPartial<InterestedParty> | undefined;
}

export function isInterestedPartySwitchEnabled({
  defaultInterestedParty,
  isLandlord,
}: IsInterestedPartySwitchEnabledArgs): boolean {
  if (isLandlord) {
    return true;
  }

  if (!defaultInterestedParty) {
    return false;
  }

  return Boolean(
    defaultInterestedParty.email && defaultInterestedParty.fullName,
  );
}
